import { render } from "./VetMediaPublic.vue?vue&type=template&id=2a3a1c4e&scoped=true"
import script from "./VetMediaPublic.vue?vue&type=script&lang=js"
export * from "./VetMediaPublic.vue?vue&type=script&lang=js"

import "./VetMediaPublic.vue?vue&type=style&index=0&id=2a3a1c4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3a1c4e"]])

export default __exports__